<template>
  <div v-if="messages.length" class="is-size-6">
    <div
      class="columns is-gapless is-vcentered notification mb-1 py-2 has-text-danger light-red-background cursor-pointer"
      @click="isOpen = !isOpen"
    >
      <div class="column is-narrow">
        <b-icon icon="alert-circle-outline" />
      </div>
      <div class="column">
        <div class="has-text-weight-bold">
          Booking error details ({{ messages.length }} 
          {{ messages.length === 1 ? "error" : "errors" }}): 
        </div>
      </div>
      <div class="column is-narrow">
        <b-icon :icon="isOpen ? 'menu-down' : 'menu-up'" />
      </div>
    </div>
    <div v-if="isOpen" class="light-red-background">
      <ul
        v-for="message of messages"
        :key="message"
        class="is-gapless is-vcentered notification mb-1 has-text-left has-text-danger light-red-background"
      >
        <li> {{ message }}</li>
    </ul>
    </div>
  </div>
</template>

<script>
import errorLibrary from "@/modules/amadeusErrorCodes.js";

export default {
  props: {
    bookingKey: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      errorLibrary,   
      messages: [],
      isOpen: false,
    };
  },
  async created() {
    this.messages = await this.getMessages();
  },
  methods: {
    async getMessages() {
      const messages = [];
      const body = { bookingKey: this.bookingKey };
      const url = "amadeus/pnr/multi-checkout/status";
      const response = await this.$app.huddleLabsServerCall(url, body);

      for (const { code, message } of response.errors ?? []) {
        const errorByCode = this.errorLibrary.find((error) => {
          return error.code == code;
        });
        const errorByMessage = this.errorLibrary.find((error) => {
          return error.code == code && message.includes(error.text);
        });

        if (errorByMessage) {
          messages.push(errorByMessage.displayMessage);
        } else if (errorByCode) {
          messages.push(errorByCode.displayMessage);
        }
      }

      return messages;
    },
  },
};
</script>

<style scoped>
.cursor-pointer {
  cursor: pointer;
}
.light-red-background {
  background-color: #ffede9;
}
</style>
